import React, { useEffect } from "react";
import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/joy";
import timeInfo from "../../utils/timeInfo";
import { getCurrentTimeZone, getCurrentLocale } from "../../utils/timeUtils";

const LeagueDetails = ({ formData, setFormData }) => {
    useEffect(() => {
        // Set default values
        setFormData((prev) => ({
            ...prev,
            timeZone: getCurrentTimeZone(),
            locale: getCurrentLocale(),
        }));
    }, [setFormData]);

    // Fallback to empty arrays if timeInfo is undefined or empty
    const timeZoneOptions = timeInfo?.timeZones || [];
    const localeOptions = timeInfo?.localeCodes || [];

    return (
        <div className="form-container">
            <h2>League Basic Information</h2>
            <TextField
                label="League Name"
                value={formData.leagueName}
                onChange={(e) => setFormData((prev) => ({ ...prev, leagueName: e.target.value }))}
                fullWidth
                margin="normal"
            />
            <TextField
                label="League Location"
                value={formData.leagueLocation}
                onChange={(e) => setFormData((prev) => ({ ...prev, leagueLocation: e.target.value }))}
                fullWidth
                margin="normal"
            />
            <Autocomplete
                value={formData.timeZone}
                options={timeZoneOptions}
                onChange={(e, newValue) => setFormData((prev) => ({ ...prev, timeZone: newValue }))}
                renderInput={(params) => <TextField {...params} label="Time Zone" />}
            />
            <Autocomplete
                value={formData.locale}
                options={localeOptions}
                onChange={(e, newValue) => setFormData((prev) => ({ ...prev, locale: newValue }))}
                renderInput={(params) => <TextField {...params} label="Locale" />}
            />
        </div>
    );
};

export default LeagueDetails;